import { gql, useQuery } from '@apollo/client'
import React from 'react'
import { getConfiguration } from '../apollo/queries'

const GETCONFIGURATION = gql`
  ${getConfiguration}
`

const ConfigurationContext = React.createContext({})

export const ConfigurationProvider = props => {
  const { loading, data, error } = useQuery(GETCONFIGURATION)

  console.log('Configuration Query - Loading:', loading)
  console.log('Configuration Query - Error:', error)
  console.log('Configuration Query - Data:', data)

  const configuration =
    loading || error || !data.configuration
      ? { currency: '', currencySymbol: '', deliveryRate: 0 }
      : data.configuration

  console.log('Final Configuration Object:', configuration)
  console.log('Google API Key from config:', configuration.googleApiKey)

  return (
    <ConfigurationContext.Provider value={configuration}>
      {props.children}
    </ConfigurationContext.Provider>
  )
}
export const ConfigurationConsumer = ConfigurationContext.Consumer
export default ConfigurationContext
